import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ru from './locales/ru.json';
import en from './locales/en.json';

/** Включить кнопку RU/EN в шапке и в мобильном меню */
export const SHOW_LANGUAGE_SWITCHER = false;

if (SHOW_LANGUAGE_SWITCHER) {
  i18n.use(LanguageDetector);
}

i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
  },
  fallbackLng: 'ru',
  interpolation: {
    escapeValue: false,
  },
  ...(SHOW_LANGUAGE_SWITCHER
    ? {
        detection: {
          order: ['localStorage', 'navigator'],
          caches: ['localStorage'],
        },
      }
    : { lng: 'ru' }),
});

export default i18n;
